import { Flex, Heading, Button, Input, FormControl, FormLabel, RadioGroup, Radio, Spinner } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import SettingsBreadcrumb from '../../../../components/SettingsBreadcrumb'
import CustomInput from '../../../../components/common/Input/input'
import * as api from '../../../../api/secretarias';
import Swal from 'sweetalert2'
import './editar-secretaria.scss'

interface Secretaria {
  codSecretaria: number;
  dscSecretaria: string;
  numAtivo: number;
}

function EditarSecretaria() {
  const [secretarias, setSecretarias] = useState<Secretaria | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate()
  const { id } = useParams();

  const fetchObterSecretaria = async () => {
    setLoading(true);
    if (!id) return;
    try {
      const data = await api.obterSecretaria(Number(id));
      setSecretarias(data);
      setFormValues({
        codSecretaria: { value: data.codSecretaria, error: false },
        dscSecretaria: { value: data.dscSecretaria, error: false },
        numAtivo: { value: data.numAtivo, error: false },
      });
    } catch (error) {
      console.error('Erro ao obter secretaria:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchObterSecretaria();
  }, [id]);

  const [formValues, setFormValues] = useState<{
    codSecretaria: { value: string; error: boolean };
    dscSecretaria: { value: string; error: boolean };
    numAtivo: { value: any; error: boolean };
  }>({
    codSecretaria: { value: '', error: false },
    dscSecretaria: { value: '', error: false },
    numAtivo: { value: '', error: false },
  });

  const isFormValid = () => {
    const { codSecretaria, dscSecretaria } = formValues;

    return (
      codSecretaria.value && dscSecretaria.value &&
      (dscSecretaria.value.length >= 3 && dscSecretaria.value.length <= 150)
    );
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormValues({
      ...formValues,
      [field]: {
        error: false,
        value
      }
    });
  };

  const handleSubmit = async () => {
    const {
      codSecretaria,
      dscSecretaria,
      numAtivo,
    } = formValues;
    
    const params = {
      codSecretaria: codSecretaria?.value,
      dscSecretaria: dscSecretaria.value || null,
      numAtivo: Number(numAtivo.value),
    };
  
    setLoading(true);
    try {
      await api.editarSecretaria(Number(id), params);

      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Secretaria editada com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/configuracao/gerenciar-secretarias");
      });
    } catch (error) {
      console.error("Erro ao editar secretaria:", error);
      Swal.fire({
        icon: "error",
        title: "Ocorreu um erro!",
        text: "Erro ao editar secretaria. Tente novamente mais tarde.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/configuracao/gerenciar-secretarias");
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        mb="20px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Editar Secretaria
      </Heading>
      {loading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <><div className="row mb-3">
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Código</FormLabel>
              <Input
                type="number"
                placeholder='Digite um código'
                isReadOnly
                backgroundColor='#f5f5f5'
                cursor='not-allowed'
                variant="outline"
                borderColor="gray.300"
                _hover={{
                  borderColor: 'blue.500',
                }}
                _focus={{
                  borderColor: 'blue.500',
                  boxShadow: '0 0 0 1px blue.500',
                }}
                value={formValues.codSecretaria.value}
              />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired>
              <FormLabel mb="8px">Descrição</FormLabel>
              <CustomInput
                placeholder='Digite uma descrição'
                value={formValues.dscSecretaria.value}
                onChange={(e) => handleFieldChange('dscSecretaria', e.target.value)}
                maxLength={160}
                minLength={3} />
            </FormControl>
          </div>
          <div className="col-md-6 mb-4">
            <FormControl isRequired marginBottom={'24px'}>
              <FormLabel mb="8px">Situação</FormLabel>
              <RadioGroup
                mt={3.5}
                onChange={(value) => handleFieldChange('numAtivo', Number(value))}
                value={formValues.numAtivo.value.toString()}
              >
                <Radio value="1" mr={5}>Ativo</Radio>
                <Radio value="0">Inativo</Radio>
              </RadioGroup>
            </FormControl>
          </div>

        </div>
          <Flex justifyContent={'end'}>
            <Button type="submit" m="6px" onClick={() => navigate('/cms/configuracao/gerenciar-secretarias')}>
              Desistir
            </Button>
            <Button
              type="submit"
              m="6px"
              color="#FFF"
              bgColor="#1665D8"
              _hover={{ opacity: 0.8 }}
              onClick={() => {
                handleSubmit()
                // navigate(-1);
              }}
              isDisabled={!isFormValid()}
            >
              Editar Secretaria
            </Button>
          </Flex>
        </>
      )}
    </Flex>
  )
}

export default EditarSecretaria;
